<template>
<div class="chapter">
<div class="inner_page">
<div id="Part-One.html" xml:lang="en-US">
<div class="story">
<p class="ch-part"><a id="Anchor-1"></a>PART ONE:<br/>MURKY TRUTHS</p>
<p class="body-text"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part_One.vue?09a1aad9